export const FETCH_EXPENSE_EVENTS = 'FETCH_EXPENSE_EVENTS';
export const FETCH_EXPENSE_EVENTS_SUCCESS = 'FETCH_EXPENSE_EVENTS_SUCCESS';
export const FETCH_EXPENSE_EVENTS_ERROR = 'FETCH_EXPENSE_EVENTS_ERROR';

export const fetchExpenseEvents = () => ({ type: FETCH_EXPENSE_EVENTS });
export const fetchExpenseEventsSuccess = (payload: any) => ({ type: FETCH_EXPENSE_EVENTS_SUCCESS, payload });
export const fetchExpenseEventsError = (payload: any) => ({ type: FETCH_EXPENSE_EVENTS_ERROR, payload });
